/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React from "react";
import CustomDataGrid from "../../components/Shared/Table/CustomDataGrid";
import { prepareTemplateLogDataGrid } from "../Configuration/helpers";
import { GridToolbarContainer } from "@mui/x-data-grid";
import { Typography } from "@mui/material";
import { useTemplateLogsData } from "./hooks";



const TemplateLogs: React.FC = () => {
  const { data = [], isLoading, allTemplateLogsColumns } = useTemplateLogsData();
  const rowsData = prepareTemplateLogDataGrid(data) || [];

  const DataGridTitle = () => {
    return (
      <GridToolbarContainer sx={{ justifyContent: "space-between" }}>
        <Typography variant="body2" >{`Showing ${rowsData?.length || 0} results`}</Typography>
      </GridToolbarContainer>
    )
  }

  return (
    <div className="w-full">
      <CustomDataGrid
        tableId="templateLog"
        sx={{ height: "420px" }}
        rows={rowsData}
        columns={allTemplateLogsColumns}
        rowCount={rowsData?.length}
        loading={isLoading}
        disableColumnMenu={true}
        //getRowId={(row: ITemplates) => row.id}
        // onRowClick={handleRowClicked}
        slots={{ toolbar: DataGridTitle }}
        hideFooter={true}
      />
    </div>
  );
};

export default TemplateLogs;
